export default __webpack_public_path__ + "build/1ac6f997d14840a8eaa2859b983f27ae.svg";